import React from 'react';
import {Button, Stack} from "react-bootstrap";
import {Link, useNavigate, useParams} from "react-router-dom";
import {ButtonDelete} from "../../../_components/DeleteButton";
import {useAlert, useAuth} from "../../../../context";
import {ColumnizeText, OurClearAlert, SingleText} from "../../../_components";
import {isoTimestampToReadableDate} from "../utilities/readableDate";
import {PageTitle} from "../../../_components";
import {Formik, Form as FormikForm} from "formik";
import {useCountry} from "./useCountry";
import {WhiteCard} from "../../../device/_components/WhiteCard";

export function AddEditCountry() {
    const {coid} = useParams()
    const {userId} = useAuth()
    const {success} = useAlert()
    const navigate = useNavigate()


    const {
        value,
        validationSchema,
        addItem,
        editItem,
        deleteItem,
        errorValue,
        clearErrorValue,
    } = useCountry(userId, coid)

    const edit = coid !== "add"

    function handleSubmit(values, actions) {
        if (edit) {
            editItem(values)
                .then(msg => {
                    success(msg)
                    navigate(-1)
                })
                .catch(console.warn)
                .finally(() => actions.setSubmitting(false))
        } else {
            addItem(values)
                .then(msg => {
                    success(msg)
                    navigate(-1)
                })
                .catch(console.warn)
                .finally(() => actions.setSubmitting(false))
        }
    }

    function handleOnDelete() {
        deleteItem()
            .then(msg => {
                success(msg)
                navigate(-1)
            })
            .catch(console.warn)
    }

    return (
        <>
            <OurClearAlert variant="danger" msg={errorValue} onClear={clearErrorValue}/>

            <PageTitle title="Country Details">{edit ? "Edit" : "Add"} country.</PageTitle>

            <Formik validationSchema={validationSchema} onSubmit={handleSubmit} initialValues={value} enableReinitialize={true}>
                {({isSubmitting, resetForm}) => (
                    <FormikForm>
                        <WhiteCard>
                            <ColumnizeText>
                                <SingleText name="name" label="Name" maxLength="64"/>
                                <SingleText name="code" label="Code" maxLength="4"/>
                            </ColumnizeText>
                        </WhiteCard>

                        <WhiteCard>
                            <SingleText name="vat" label="VAT" postfix="%" className={"w-50"}/>
                        </WhiteCard>

                        <Stack className="my-2 text-secondary">
                            {value.created_at && <span>Created at: {isoTimestampToReadableDate(value.created_at)}</span>}
                            {value.updated_at && <span>Updated at: {isoTimestampToReadableDate(value.updated_at)}</span>}
                        </Stack>

                        <Stack direction="horizontal" gap="2" className="py-3 justify-content-end">
                            <Button as={Link} variant="link" to={-1}>Go back</Button>
                            <Button type="reset" variant="secondary" onClick={resetForm}>Reset</Button>
                            {edit && <ButtonDelete variant="danger" onDelete={handleOnDelete} value={value.name}>Delete</ButtonDelete>}
                            <Button type="submit" variant="success" disabled={isSubmitting}>{edit ? "Edit" : "Add"}</Button>
                        </Stack>

                    </FormikForm>
                )}
            </Formik>
        </>
    )
}